export const sortTravellers = (travellers: Array<App.Checkout.TravellerForm>) =>
  travellers.sort((current, next) => current.id.localeCompare(next.id))
